webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(9);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Stories = __webpack_require__(10);
	
	var _Stories2 = _interopRequireDefault(_Stories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    stories: _Stories2.default
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(8);
	
	exports.default = {
	  name: 'stories',
	  vueHtmlEditor: 'vue-html-editor',
	  components: {},
	  data: function data() {
	    return {
	      msg: 'Story-Telling',
	      task: 'Erzähl mir was zum Thema: ',
	      topic: '',
	      anzahl: 6,
	      min: 1,
	      max: 84,
	      list: [],
	      text: 'Hallo',
	      alt: [' Sprechblase mit Buchstabe "i". ', ' Flugzeug. ', ' grimmiges Gesicht. ', ' Apfel. ', ' Ritterhelm. ', ' Zelle in Pflanze oder Tier. ', ' Biene. ', ' Vogel. ', ' WLAN-Symbol. ', ' Mond und zwei Sterne. ', ' Käfer. ', ' Hochhaus. ', ' Kaktus. ', ' Fotoapparat. ', ' Zelt. ', ' Uhr. ', ' Clouns-Fisch. ', ' Krabbe. ', ' Krone. ', ' Baum. ', ' Würfel. ', ' @-Symbol. ', ' Facebook-Logo. ', ' Hand verdeckt Gesicht. ', ' Zauberstab. ', ' Haus in Flammen. ', ' Firewall für einen Computer. ', ' Taschenlampe. ', ' Kopf von der Seite mit Ausrufungszeichen darin. ', ' Springbrunnen. ', ' einzelne Flamme wie auf einer Kerze. ', ' Weltkugel. ', ' Alien. ', ' Haus. ', ' Python. ', ' Lampe angeschaltet. ', ' Selfie. ', ' Regenwolke. ', ' Schlüssel. ', ' Leiter im Schwimmbad. ', ' zwei Pyramiden und die Sonne. ', ' Pfleil nach links oben zeigend. ', ' Rettungsring. ', ' Blitz oder Strom. ', ' Tischlampe. ', ' Buch (aufgeschlagen). ', ' Vorhängeschloss geschlossen. ', ' Magnet. ', ' Baum mit Ring um dem Stamm. ', ' Noten (Musik). ', ' Oktopus. ', ' Fallschirm. ', ' Bohrmaschine. ', ' Büroklammer. ', ' Hand (alle fünf Finger gestreckt). ', ' Mütze (Polizei, Schaffner, Pilot, ...). ', ' Drucker. ', ' Puzzle-Teil. ', ' Fragezeichen. ', ' Smiley mit Fragezeichen. ', ' Fußabdruck. ', ' Frowny (trauriger Smiley. ', ' Balkenwaage. ', ' Bildschirm und Lupe. ', ' Lupe. ', ' Paragraph. ', ' Totenkopf. ', ' zwei Zahnräder. ', ' Schaf. ', ' Smiley --  gerader Mund. ', ' Axt/Beil. ', ' Sprechblase ohne Text. ', ' Hut, Maske und Stock. ', ' Komet. ', ' Erlenmeyerkolben. ', ' zwei Masken. ', ' japanisches Eingangstor. ', ' Smartfone. ', ' Karte mit Weg und Zielmarkierung. ', ' Schildkröte. ', ' Brille. ', ' Auge. ', ' Brücke. ', ' Krückstock. ']
	    };
	  },
	
	  methods: {
	    dice: function dice() {
	      this.list = [];
	      do {
	        var x = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
	        console.log(this.list.indexOf(x), this.list.length, x);
	        if (this.list.indexOf(x) < 0) {
	          this.list.push(x);
	        }
	      } while (this.list.length < this.anzahl);
	    }
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/methopedia-logo.8cd2aba.png";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/secaware-banner.ce0a542.png";

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(5)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(2),
	  /* template */
	  __webpack_require__(12),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(4)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(3),
	  /* template */
	  __webpack_require__(11),
	  /* scopeId */
	  "data-v-227bf069",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hello"
	  }, [_vm._m(0), _vm._v(" "), _c('hr', {
	    attrs: {
	      "width": "60%"
	    }
	  }), _vm._v(" "), _c('hr', {
	    attrs: {
	      "width": "40%"
	    }
	  }), _vm._v(" "), _c('hr', {
	    attrs: {
	      "width": "20%"
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("  " + _vm._s(_vm.msg) + " ")]), _vm._v(" "), _c('hr', {
	    attrs: {
	      "width": "20%"
	    }
	  }), _vm._v(" "), _c('hr', {
	    attrs: {
	      "width": "40%"
	    }
	  }), _vm._v(" "), _c('hr', {
	    attrs: {
	      "width": "60%"
	    }
	  }), _vm._v(" "), _c('p', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.topic),
	      expression: "topic"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Dein Thema?"
	    },
	    domProps: {
	      "value": (_vm.topic)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.topic = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.anzahl),
	      expression: "anzahl"
	    }],
	    attrs: {
	      "name": "anzahl"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.anzahl = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l(([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]), function(i) {
	    return _c('option', {
	      domProps: {
	        "value": i
	      }
	    }, [_vm._v(_vm._s(i))])
	  })), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.dice()
	      }
	    }
	  }, [_vm._v("Würfeln ...")])]), _c('h2', [_vm._v(_vm._s(_vm.task) + " " + _vm._s(_vm.topic))]), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
	    return _c('li', [_c('img', {
	      staticClass: "randimg",
	      attrs: {
	        "src": '../static/images/' + item + '.svg',
	        "alt": _vm.alt[item - 1]
	      }
	    })])
	  }))])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(7),
	      "height": "70px"
	    }
	  })])
	}]}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "logo",
	      "src": __webpack_require__(6)
	    }
	  }), _vm._v(" "), _c('stories')], 1)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.b203dcf79de28522fab5.js